export const SET_HRMS1AX_INDEX_DISP = 'SET_HRMS1AX_INDEX_DISP'
export const GET_HRMS1AX_INDEX_DISP = 'GET_HRMS1AX_INDEX_DISP'
export const SET_HRMS1AX_COLUMNS = 'SET_HRMS1AX_COLUMNS'
export const GET_HRMS1AX_COLUMNS = 'GET_HRMS1AX_COLUMNS'
export const SET_HRMS1AX_LABELS = 'SET_HRMS1AX_LABELS'
export const GET_HRMS1AX_LABELS = 'GET_HRMS1AX_LABELS'
export const RECEIVED_HRMS1AX_COLUMNS_LABELS = 'RECEIVED_HRMS1AX_COLUMNS_LABELS'
export const SET_HRMS1AX_INDEX = 'SET_HRMS1AX_INDEX'
export const GET_HRMS1AX_INDEX = 'GET_HRMS1AX_INDEX'
export const RECEIVED_HRMS1AX_INDEX = 'RECEIVED_HRMS1AX_INDEX'
export const GET_HRMS1AX_MAX_ROWSPAN = 'GET_HRMS1AX_MAX_ROWSPAN'



// WEBPACK FOOTER //
// ./src/store/modules/hrms1ax/mutation-types.js